import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../Redux/hooks";
import { useParams } from "react-router-dom";
import { fetchUrlsData } from "../../../../Redux/actions/appCustomizationAction";
import { setData } from "../../../../Redux/reducers/appCustomizationSlice";
import {
  Box,
  LinearProgress,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import {
  NoDataContainer,
  StyledTableCell,
  TableBorderRadiusTopLeftRight,
} from "../../../Common/styles/table";
import AddUrlModal from "./Modals/AddUrlModal";

const URLScreen = () => {
  const urlsData = useAppSelector((state) => state.appCustomization.urlsData);
  const loading = useAppSelector((state) => state.appCustomization.loading);
  const toggleLoader = useAppSelector(
    (state) => state.appCustomization.toggleLoader
  );
  const dispatch = useAppDispatch();
  const { id: studyId } = useParams();
  const showModal = useAppSelector(
    (state) => state.appCustomization.showAddUrlModal
  );

  useEffect(() => {
    dispatch(fetchUrlsData(studyId));
    return () => {
      dispatch(setData([]));
    };
  }, [dispatch, studyId, toggleLoader]);

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: "1px",
        height: "100%",
        overflow: "auto",
        py: 2.5,
        px: 2,
        alignItems: "center",
        width: "100%",
      }}
    >
      <Table sx={TableBorderRadiusTopLeftRight}>
        <TableHead>
          <TableRow>
            <StyledTableCell>URL</StyledTableCell>
            <StyledTableCell>Date</StyledTableCell>
          </TableRow>
        </TableHead>
        {!loading && urlsData.length > 0 && (
          <>
            <TableBody>
              {urlsData?.map((url: any) => (
                <TableRow key={url?.key}>
                  <StyledTableCell>{url?.url || "-"}</StyledTableCell>
                  <StyledTableCell>{url?.date}</StyledTableCell>
                </TableRow>
              ))}
            </TableBody>
          </>
        )}
      </Table>
      {!loading && urlsData.length === 0 && (
        <NoDataContainer>
          <Typography variant="body1" color="gray">
            No Data
          </Typography>
        </NoDataContainer>
      )}
      {loading && (
        <Box sx={{ width: "100%" }}>
          <LinearProgress />
        </Box>
      )}
      {showModal && <AddUrlModal />}
    </Box>
  );
};

export default URLScreen;
